import './SoilErosionBlog.css'
import Causes from './Heros/Causes';
import ErodedMass from './Heros/ErodedMass';
import ErosionRate from './Heros/ErosionRate';
import CaseStudy from './Heros/CaseStudy';

function SoilErosionBlog() {
    return (
        <>
            <Causes />
            <ErodedMass />
            <ErosionRate />
            <CaseStudy />
        </>
    )
}

export default SoilErosionBlog;